import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/themeFour/misteryGift.png'


const _hoisted_1 = { class: "cardContainer" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "dailyPrize" }
const _hoisted_4 = {
  key: 0,
  class: "claimedButton"
}

import { ref } from 'vue';
import ClaimPopup from './claimPopup.vue';
import StatusPopup from '@/components/common/statusPopup.vue';
import LoadingScreen from '@/components/common/loadingScreen.vue';
import { processClaimReward } from '@/view/misteryBox/supportScript';


export default /*@__PURE__*/_defineComponent({
  __name: 'giftCard',
  props: {
    title: {},
    bottomText: {},
    rewardType: {},
    alreadyClaimed: { type: Boolean },
    exchangeType: {}
  },
  emits: ['updateInfo'],
  setup(__props: any, { emit: __emit }) {

const emits = __emit

const props = __props
const loadingRef = ref()
const statusRef = ref()
const isSuccess = ref(false)
const toastContent = ref('')
const claimRef = ref()
const showError = (message: string) => {
    toastContent.value = message;
    isSuccess.value = false;
    statusRef.value.open()
}
const onClickButton = () => {
    claimReward(props.rewardType)
}

const claimReward = async (rewardType?: number) => {
    await processClaimReward(
        {
            rewardType,
            exchangeType: props.exchangeType
        },
        {
            onStart: () => loadingRef.value?.open(),
            onSuccess: (res) => {
                emits('updateInfo');
                claimRef.value?.open({
                    exchangeType: props.exchangeType,
                    reward: res.reward,
                });
            },
            onError: (err) => showError(err),
            onFinally: () => loadingRef.value?.close(),
        }
    );
};

return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_van_icon, {
        name: "checked",
        size: "20px",
        color: "#fff",
        style: {"margin-right":"10px"}
      }),
      _createTextVNode(" " + _toDisplayString(_ctx.title), 1)
    ]),
    _cache[0] || (_cache[0] = _createElementVNode("img", {
      src: _imports_0,
      alt: "gift card",
      style: {"width":"30%"}
    }, null, -1)),
    _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.bottomText), 1),
    _createElementVNode("div", null, [
      (_ctx.alreadyClaimed)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.rewardType === 3 ? _ctx.$t('misteryBox.alreadyClaimToday') :
                _ctx.$t('misteryBox.alreadyClaimed')), 1))
        : (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "claimButton",
            onClick: onClickButton
          }, _toDisplayString(_ctx.$t('misteryBox.clickToClaim')), 1))
    ]),
    _createVNode(ClaimPopup, {
      ref_key: "claimRef",
      ref: claimRef
    }, null, 512),
    _createVNode(StatusPopup, {
      ref_key: "statusRef",
      ref: statusRef,
      "is-show-success": isSuccess.value,
      content: toastContent.value
    }, null, 8, ["is-show-success", "content"]),
    _createVNode(LoadingScreen, {
      ref_key: "loadingRef",
      ref: loadingRef
    }, null, 512)
  ]))
}
}

})